import PropTypes from 'prop-types';

import { Modal } from '@mui/material';

import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDTypography from 'components/MDTypography';

const DwollaFailureReasonModal = ({ isOpen, onClose, dwollaVerificationFailureReasons = [] }) => {
    
    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            aria-labelledby='modal-modal-title'
            aria-describedby='modal-modal-description'>
            <MDBox
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 600,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    borderRadius: '12px',
                    p: 4,
                }}>
                <MDTypography id='modal-modal-title' variant='h4' component='h2'>
                    Reasons
                </MDTypography>
                {
                    dwollaVerificationFailureReasons?.map((failureReason) => (
                        <MDBox mt={3} mb={2} key={failureReason?.reason}>
                            <MDTypography variant='h6'>{failureReason?.reason}</MDTypography>
                            <MDTypography component='p' sx={{ fontSize: '16px', lineHeight: '24px' }}>
                                {failureReason?.description}
                            </MDTypography>
                        </MDBox>
                    ))
                }
                <MDBox align='right' marginTop='32px'>
                    <MDButton variant='gradient' color='info' onClick={onClose}>
                        Close
                    </MDButton>
                </MDBox>
            </MDBox>
        </Modal>
    );
};

DwollaFailureReasonModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    dwollaVerificationFailureReasons: PropTypes.array,
};

export default DwollaFailureReasonModal